import { Component, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { ConversationService } from '../conversation.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerComponent } from 'ngx-spinner';
import { VoiceMailsComponent } from './components/voice-mails/voice-mails.component';
import { CallHistoryComponent } from './components/call-history/call-history.component';
import { ConversationComponent } from './conversation.component';
import { NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavContent, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-communications',
    templateUrl: './communications.component.html',
    styleUrls: ['./communications.component.css'],
    standalone: true,
    imports: [NgIf, NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavContent, ConversationComponent, CallHistoryComponent, VoiceMailsComponent, NgbNavOutlet, NgxSpinnerComponent]
})
export class CommunicationsComponent implements OnInit, OnDestroy, OnChanges {
  subs = new Subscription
  badgeCount: number = 0
  isCommEnabled: boolean = false;
  login = JSON.parse(localStorage.getItem('login'))

  constructor(
    private conversationService: ConversationService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {

    if(this.login.twilioSID && this.login.defaultNumber) {
      this.isCommEnabled = true;
      this.getUnreadCount()
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.badgeCount) {
      this.badgeCount = changes.badgeCount.currentValue

    }
  }

  getUnreadCount() {
    this.subs.add(
      this.conversationService.unreadMessagesCountValue
        .pipe()
        .subscribe((data) => {
          this.badgeCount = data
        })
    )
  }

  redirectToSettings() {
      this.router.navigate(['/settings'], { relativeTo: this.route })
      sessionStorage.setItem('settingsNavActiveId', 'SMS/Calls');
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe()
  }

  triggerUnreadCount(value) {
    this.badgeCount = value;
  }
}
